import Image from 'next/image'
import {FC} from 'react'

import {CardListLayout} from '@/components/common/cards/CardListLayout'
import {CardWrapper} from '@/components/common/cards/CardWrapper'
import {Text, TextFontWeight, TextVariant} from '@/components/common/content/Text'
import {getTrademarkDisputesContent} from '@/content/trademarkDisputes'
import {useTranslation} from '@/i18n'
import {
  CONTENT_LAYOUT_WIDTH,
  TRADEMARK_DISPUTE_COMPARISON_CARD_HEIGHT_DESKTOP,
  TRADEMARK_DISPUTE_COMPARISON_CARD_HEIGHT_MOBILE,
} from '@/theme/sizing'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE, USER_TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

type IpCaseTmComparisonProps = {
  caseName: string
  comparisonOfTms: string[]
}

export const IpCaseTmComparison: FC<IpCaseTmComparisonProps> = ({caseName, comparisonOfTms}) => {
  const {t} = useTranslation()
  const {comparisonOfTrademarksTitle} = getTrademarkDisputesContent()

  return (
    <>
      <div className="wrapper">
        <Text variant={TextVariant.h2}>{t(comparisonOfTrademarksTitle)}</Text>
        <CardListLayout>
          {comparisonOfTms.map((item, index) => {
            const isImage = item.endsWith('.jpg')
            return (
              <CardWrapper key={index} numOfCardsPerRow={2} isHoverable={false}>
                <div className="card">
                  {isImage ? (
                    <div className="logo">
                      <Image
                        src={item}
                        alt={`Trademark ${index + 1} compared in ${caseName}`}
                        fill
                        sizes={`${USER_TABLET_SCREENSIZE} 50vw, calc(${CONTENT_LAYOUT_WIDTH} / 2)`}
                        style={{objectFit: 'contain'}}
                      />
                    </div>
                  ) : (
                    <Text
                      variant={TextVariant.h3}
                      element="p"
                      align="center"
                      fontWeight={TextFontWeight.regular}
                    >
                      {item}
                    </Text>
                  )}
                </div>
              </CardWrapper>
            )
          })}
        </CardListLayout>
      </div>

      <style jsx>{`
        .wrapper {
          margin-top: ${theme.spacing[6]};
        }
        .card {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;
          padding: ${theme.spacing[4]};
          min-height: ${TRADEMARK_DISPUTE_COMPARISON_CARD_HEIGHT_DESKTOP};
        }
        .logo {
          position: relative;
          width: 100%;
          height: calc(${TRADEMARK_DISPUTE_COMPARISON_CARD_HEIGHT_DESKTOP} - ${theme.spacing[6]});
        }
        @media ${MOBILE_SCREENSIZE} {
          .card {
            padding: ${theme.spacing[3]};
            min-height: ${TRADEMARK_DISPUTE_COMPARISON_CARD_HEIGHT_MOBILE};
          }
          .logo {
            height: calc(${TRADEMARK_DISPUTE_COMPARISON_CARD_HEIGHT_MOBILE} - ${theme.spacing[5]});
          }
        }
      `}</style>
    </>
  )
}
